export default "__VITE_ASSET__062e8536__"